module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module container_lg moduleSix"
  }, [_c('div', {
    ref: "scene",
    staticClass: "scene",
    style: (_vm.sceneStyles)
  }, [_c('div', {
    ref: "gymBackground",
    staticClass: "background-scale translate-down"
  }, [_c('gym')], 1), _vm._v(" "), _c('div', {
    staticClass: "layer translate-down"
  }, [_c('gymSign')], 1), _vm._v(" "), (_vm.currentSlideIndex > 36) ? _c('div', {
    staticClass: "layer"
  }, [_c('lab')], 1) : _vm._e(), _vm._v(" "), (_vm.currentSlideIndex < 12) ? _c('div', {
    staticClass: "layer"
  }, [_c('computer-lab')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "layer translate-down"
  }, [(_vm.currentSlideIndex > 17) ? _c('gym-door') : _vm._e(), _vm._v(" "), (_vm.currentSlideIndex > 11 && _vm.currentSlideIndex < 37) ? _c('dylan', {
    attrs: {
      "data": _vm.dylanData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "layer",
    class: _vm.translateDown
  }, [(_vm.currentSlideIndex > 36) ? _c('ria', {
    attrs: {
      "data": _vm.riaData
    }
  }) : _vm._e(), _vm._v(" "), _c('aye', {
    attrs: {
      "data": _vm.ayeData,
      "additionalData": _vm.ayeAdditionalData
    }
  }), _vm._v(" "), (_vm.currentSlideIndex < 37) ? _c('devyn', {
    attrs: {
      "data": _vm.devynData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "layer translate-down"
  }, [(_vm.currentSlideIndex > 11 && _vm.currentSlideIndex < 37) ? _c('gym-front') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [(_vm.currentSlideIndex < 12) ? _c('computer-lab-front') : _vm._e()], 1), _vm._v(" "), (_vm.currentSlideIndex > 11) ? _c('div', {
    staticClass: "layer translate-down"
  }, [(_vm.currentSlideIndex < 18) ? _c('joe') : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "layer translate-down"
  }, [(_vm.currentSlideIndex > 11 && _vm.currentSlideIndex < 18) ? _c('gym-door') : _vm._e(), _vm._v(" "), (_vm.currentSlideIndex > 11 && _vm.currentSlideIndex < 37) ? _c('skylar', {
    attrs: {
      "data": _vm.skylarData
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "layer"
  }, [(_vm.currentSlideIndex > 36) ? _c('cord') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.showBlackOverlay) ? _c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "black-overlay"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(!_vm.hideModalText) ? _c('div', {
    staticClass: "layer"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('h1', {
    staticClass: "modal_text h1-large"
  }, [_vm._v(_vm._s(_vm.blackModalText.header))]), _vm._v(" "), _c('p', {
    staticClass: "modal_text"
  }, [_vm._v(_vm._s(_vm.blackModalText.subHeader))])])]) : _vm._e()])], 1) : _vm._e()]), _vm._v(" "), (_vm.currentSlideIndex < 5) ? _c('div', {
    staticClass: "layer"
  }, [_c('library-doors', {
    attrs: {
      "data": _vm.libraryDoorsData,
      "showOnEdge": _vm.showDoorsOnEdge
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "layer",
    class: _vm.labDoorsVisible
  }, [_c('lab-doors', {
    attrs: {
      "data": _vm.labDoorsData,
      "showOnEdge": _vm.showDoorsOnEdge
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layer layer-full index-2",
    class: _vm.modalLayerClass
  }, [_c('modal', {
    attrs: {
      "active": _vm.modalActive,
      "text": _vm.modalText,
      "ind": _vm.modalInd,
      "modalStyle": _vm.modalStyle
    },
    on: {
      "close": _vm.closeModalLayer
    }
  })], 1), _vm._v(" "), _c('control-panel', {
    attrs: {
      "text": _vm.activeText,
      "control_panel_active": _vm.controlPanelActive
    },
    on: {
      "textProgress": _vm.updateScene
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-114e4580","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_6/module_6.vue
// module id = 1028
// module chunks = 1